<template>
    <div class="section-box">
        <el-row class="row-bg">
            <el-col :span="12" style="text-align: left;line-height: 36px;">
                <el-badge :value="total" :max="99" :hidden="form.applystatus !== 1">
                    <el-button size="mini" :class="form.applystatus ==1 ?'selected':''" @click="titleClick(1)">审核中</el-button>
                </el-badge>
                <el-button size="mini" style="margin-left: 25px;" :class="form.applystatus ==2 ?'selected':''" @click="titleClick(2)">审核通过</el-button>
                <el-button size="mini" style="margin-left: 25px;" :class="form.applystatus ==3 ?'selected':''" @click="titleClick(3)">审核不通过</el-button>
            </el-col>
            <el-col :span="12" style="text-align: right;">
                <el-button size="medium" type="primary" @click="accRecordPass(2,3)" v-if="form.applystatus == 1">批量拒绝</el-button>
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                <!-- <el-button size="medium" type="primary" icon="el-icon-download" @click="downloadFile()">下载数据</el-button> -->
            </el-col>
        </el-row>
        <!-- 列表 -->
        <el-table ref="tableData"
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="666"
            border
            @selection-change="handleSelectionChange"
            v-loading="listLoading" 
            v-show="form.applystatus == 1"
            >
            <!-- eslint-disable  -->
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="申请用户ID">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.userid" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.userid || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="申请人姓名">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.username" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.username || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="联系方式" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <!-- @keyup.enter.native="GetCouponsList()" -->
                        <el-input size="mini" v-model="form.phone" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.phone || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="申请时间">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.createtime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.createtime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="申请描述" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.expertdesc" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.expertdesc || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" width="280">
                <template slot-scope="scope">
                    <el-button size="mini" @click="lookExpertdesc(scope.row.expertdesc)">详情</el-button>
                    <el-button type="primary" size="mini" @click="accRecordPass(1,2,scope.row.id)">审核通过</el-button>
                    <el-button type="danger" size="mini" @click="accRecordPass(2,3,scope.row.id)">审核不通过</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-table ref="tableData"
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="666"
            border
            v-loading="listLoading" 
            v-show="form.applystatus != 1"
            >
            <!-- eslint-disable  -->
            <el-table-column label="申请用户ID">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.userid" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.userid || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="申请人姓名">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.username" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.username || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="联系方式" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <!-- @keyup.enter.native="GetCouponsList()" -->
                        <el-input size="mini" v-model="form.phone" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.phone || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="处理时间">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.dealtime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.dealtime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="申请描述" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.expertdesc" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.expertdesc || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="处理人" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.dealpersonname" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.dealpersonname || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                    <el-button size="mini" @click="lookExpertdesc(scope.row.expertdesc)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.pageNum"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>

        <el-dialog
            title="查看专家描述"
            :visible.sync="expertdescShow"
            width="30%"
        >
            <span>{{text}}</span>
        </el-dialog>
    </div>
</template>
<script>
import {
    expertList,             //大咖审核列表
    expertModi,             //大咖审核通过 || 不通过
    authStatusModi,         //国家认证|原厂认证-面试通过|不通过
} from "@/service/examination";
import { 
  getStorageToken,
  getStorageUserRoleId
} from '@/utils/store'
  export default {
    data() {
        return {
            listLoading: false,
            form: {
                pageNum: 1,
                pageSize: 10,
                rational: true,

                applystatus: 1,         //申请状态，1 已申请待审核，2 审核成功，3 审核被拒
                dealpersonid: '',       //处理人id
                dealpersonname: '',     //处理人名称
                phone: '',              //联系方式
                expertdesc: '',         //专家描述
                userid: '',             //用户id
                username: '',           //用户名
                createtime: [],         //创建时间
                dealtime: [],           //处理时间
            },
            searchData:{},
            oraginForm:{},
            total: 0,                       //总条数
            tableData:[],
            num: 0,                         //选中的数量
            selected_items:{},

            expertdescShow: false,
            text: '',
        }
    },
    activated(){
        this.handleSearch()
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        titleClick(type){
            this.form.applystatus = type;
            this.selected_items = {}
            this.num = 0
            this.handleSearch()
        },
        //渲染列表
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.handleCurrentChange(1)
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.pageNum = val
            this.searchData.pageNum = val
            this.GetCouponsList()
        },
        //翻页
        handleSizeChange(val) {
        if (this.listLoading) return
            this.form.pageNum = 1
            this.form.pageSize = val
            this.searchData.pageNum = 1
            this.searchData.pageSize = val
            this.GetCouponsList()
        },
        async GetCouponsList(){
            const _this = this;

            this.listLoading = true
            let data = JSON.parse(JSON.stringify(this.searchData))
            !data.dealpersonid && delete data.dealpersonid
            !data.dealpersonname && delete data.dealpersonname
            !data.phone && delete data.phone
            !data.expertdesc && delete data.expertdesc
            !data.userid && delete data.userid
            !data.username && delete data.username



            if (data.createtime instanceof Array && data.createtime.length) {
                data.createtimebegin = data.createtime[0] + " 00:00:00";
                data.createtimeend = data.createtime[1] + " 23:59:59";
            }
            delete data.createtime;
            if (data.dealtime instanceof Array && data.dealtime.length) {
                data.dealtimebegin = data.dealtime[0] + " 00:00:00";
                data.dealtimeend = data.dealtime[1] + " 23:59:59";
            }
            delete data.dealtime;
            let res = await expertList(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }

           const old = JSON.parse(JSON.stringify(this.selected_items));
           this.selected_items = {};

            this.tableData = res.Data.datas;
            this.total = res.Data.total;
            this.num = Object.keys(old).length;
            this.$forceUpdate();
            if (Object.keys(old).length) {
                this.$nextTick(() => {
                    for (var idx1 in _this.tableData) {
                        const item1 = _this.tableData[idx1];
                        if (old[item1.id]) {
                            _this.$refs.tableData.toggleRowSelection(item1);
                        }
                    }
                    for (var key1 in old) {
                        const item2 = old[key1];
                        _this.selected_items[key1] = item2;
                    }
                    _this.num = Object.keys(_this.selected_items).length;
                    _this.$forceUpdate();
                });
            }
            _this.$nextTick(()=>{
                _this.$refs.tableData.doLayout()
            })
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
            this.selected_items = {};
            this.$forceUpdate();

        },
        // table选中
        handleSelectionChange(val) {
            for (var idx in this.tableData)
            {
                const item = this.tableData[idx];
                if (this.selected_items[item.id]) delete this.selected_items[item.id];
            }

            for (var idxs in val)
            {
                const item2 = val[idxs];
                this.selected_items[item2.id] = item2;
            }
            this.num = Object.keys(this.selected_items).length;
        },
        // 点击通过不通过按钮
        accRecordPass(is,type,id){
            let data = {}
            data.ids = []
            data.applystatus = type
            data.nuserId = getStorageUserRoleId()
            data.nuserType = 1
            if(id) {
                data.ids = [id]
            }else{
                if(JSON.stringify(this.selected_items) == '{}') {
                    return this.$message.error('请选择审核不通过人员')
                }
                for (var key in this.selected_items) {
                    const item = this.selected_items[key];
                    data.ids.push(item.id)
                }
            }
            let tips = '通过'
            if(is == 2) tips = '不通过'
            this.$confirm('确认'+ tips +'大咖审核吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                expertModi(data).then(res=>{
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success('操作成功！')
                    this.GetCouponsList()
                })
            }).catch(() => {});
        },
        // 点击查看详情
        lookExpertdesc(t){
            this.expertdescShow = true
            this.text = t
        },
    }
  }
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
    .section-box {
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
</style>